import React, { useState } from 'react';
import styled from 'styled-components';
import Loader from '../Components/Loader'; 
import SuccessCard from '../Components/SuccessCard'; 
import ErrorCard from '../Components/ErrorCard'; 
import useAddfarmers from '../Hooks/FarmersHooks/useAddfarmers';
import MunicipalitySelector from '../Components/Municipality';
import ProvinceSelector from '../Components/ProvinceSelector';

const FBmasterlistAdd = ({darkMode}) => {
 
  const { loading, success, error, addimtContract } = useAddfarmers();
      const [showSuccess, setShowSuccess] = useState(false);
      const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    region: '',
    imo: '',
    system: '',
    ia_name: '',
    num: '',
    province: '',
    municipality: '',
    barangay: '',
    farmLot: '',
    lastName: '',
    firstName: '',
    middleName: '',
    status_member: '',
    status_nonMember: '',
    sector: '',
    farmArea: '',
    origOwner: '',
    partOwner: '',
    tenant: '',
    leasee: '',
    mortgage: '',
    spouseName: '',
    landowner_lastName: '',
    landowner_firstName: '',
    landowner_middleName: '',
    landowner_spouseName: '',
  });

  const [isExpanded] = useState(true);

  const formSections = [
    {
      title: null,
      fields: [
        'region',
        'imo',
        'system',
        'ia_name',
        'num',
      ],
    },
    {
      title: 'FARMER TILLERS INFORMATION',
      fields: ['province', 'municipality', 'barangay', 'farmLot', 'lastName', 'firstName', 'middleName', 'status_member', 'status_nonMember'],
    },
    {
      title: 'SPOUSE INFORMATION',
      fields: ['spouseName'],
    },
    {
      title: 'FARM INFORMATION',
      fields: ['sector', 'farmArea', 'origOwner', 'partOwner', 'tenant', 'leasee', 'mortgage'],
    },
    {
      title: 'LANDOWNERS INFORMATION',
      fields: ['landowner_lastName', 'landowner_firstName', 'landowner_middleName'],
    },
    {
      title: "LANDOWNER'S SPOUSE INFORMATION",
      fields: ['landowner_spouseName'],
    },
  ];

  const fieldLabelMap = {
    region: 'REGION',
    imo: 'IMO',
    system: 'NAME OF SYSTEM',
    ia_name: 'NAME OF IA',
    num: 'NO.',
    province: 'PROVINCE',
    municipality: 'MUNICIPALITY',
    barangay: 'BARANGAY',
    farmLot: 'FARM LOT NO.',
    lastName: 'LAST NAME',
    firstName: 'FIRST NAME',
    middleName: 'MIDDLE NAME',
    status_member: 'MEMBER',
    status_nonMember: 'NON MEMBER',
    sector: 'TSA/SECTOR',
    farmArea: 'FARM AREA (Ha)',
    origOwner: 'ORIG. OWNER',
    partOwner: 'PART OWNER / HEIRS',
    tenant: 'TENANT',
    leasee: 'LEASEE',
    mortgage: 'MORTGAGE / POWNED',
    spouseName: 'NAME',
    landowner_lastName: 'LAST NAME',
    landowner_firstName: 'FIRST NAME',
    landowner_middleName: 'MIDDLE NAME',
    landowner_spouseName: 'NAME',
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addimtContract(formData); 
  };
    

  return (
    <Container darkMode={darkMode}  isExpanded={isExpanded}>
      <FormContainer  darkMode={darkMode} isExpanded={isExpanded}>
      <Title darkMode={darkMode}><span>FARMERS BENIFICIARIES Form</span></Title>
      {loading && <LoaderOverlay><Loader /></LoaderOverlay>}
      {showSuccess && <SuccessCard onClose={() => setShowSuccess(false)} />}
      {showError && <ErrorCard errorMessage={error} onClose={() => setShowError(false)} />}
        <form onSubmit={handleSubmit}>
        {formSections.map((section, index) => (
         <CardSection darkMode={darkMode} key={index}>
           {section.title && (
             <SectionHeader darkMode={darkMode}>{section.title}</SectionHeader>
           )}
       
           {section.fields.map((key) => (
             <FieldGroup key={key} darkMode={darkMode}>
               <label htmlFor={key}>
                   {fieldLabelMap[key] || key.replace(/_/g, ' ').toUpperCase()}
               </label>
               {key === 'province' ? (
                 <ProvinceSelector
                   formData={formData}
                   setFormData={setFormData}
                   darkMode={darkMode}
                 />
               ) : key === 'municipality' ? (
                 <MunicipalitySelector
                   formData={formData}
                   setFormData={setFormData}
                   darkMode={darkMode}
                 />
               ) : ['date_organized', 'imtContract_dateSigning', 'sec_date', 'permit_date'].includes(key) ? (
                 <input
                   type="date"
                   className="form-control"
                   id={key}
                   name={key}
                   value={formData[key]}
                   onChange={handleChange}
                 />
               ) : (
                 <input
                   type="text"
                   className="form-control"
                   id={key}
                   name={key}
                   value={formData[key]}
                   onChange={handleChange}
                 />
               )}
       
             </FieldGroup>
           ))}
         </CardSection>
       ))}

          <FormButtonContainer>
            <SubmitButton darkMode={darkMode} type="submit">Add</SubmitButton>
          </FormButtonContainer>
        </form>
      </FormContainer>
    </Container>
  );
};

export default FBmasterlistAdd;

const Container = styled.div`
    padding: ${(props) => (props.isExpanded ? '1px' : '10px')};
    width: 100%;
    min-height: 90vh;
    background-size: 100%;
    background-position: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow-y: auto;
    position: relative;
    transition: transform 0.3s ease; 
    transform: ${(props) => (props.isExpanded ? 'translateX(0%)' : 'translateX(80%)')};
    height: 90%;
    margin-top: 30px;
  `;


  const FormContainer = styled.div`
  width: ${(props) => (props.isExpanded ? '75%' : '100%')};
  margin-top: 0px;
  padding-bottom: 20px;
  flex-grow: 1;
  overflow-y: auto;
  transition: width 0.3s ease;
  
`;

const Title = styled.h2`
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 10px 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  background: ${({ darkMode }) =>
    darkMode
      ? 'rgba(3, 82, 33, 0.45)'
      : 'rgba(255, 255, 255, 0.65)'};

  box-shadow: ${({ darkMode }) =>
    darkMode
      ? '0 4px 30px rgba(0, 0, 0, 0.1)'
      : '0 4px 30px rgba(0, 0, 0, 0.05)'};

  span {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(255, 255, 255, 0.6)' : '#18591d')};
    color: ${({ darkMode }) => (darkMode ? '#1a1a1a' : '#fff')};
    padding: 6px 24px;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 8px;
    position: relative;
    z-index: 1;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 2px;
    width: 30px;
    background-color: ${({ darkMode }) => (darkMode ? '#eee' : '#333')};
    margin: 0 8px;
    margin-top: 35px;
  }
`;


const LoaderOverlay = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
z-index: 9999; // on top of everything
`;

const CardSection = styled.div`
 background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(9px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  padding: 10px;
  margin-bottom: 7px;
  border-radius: 10px;
  box-shadow: ${({ darkMode }) =>
    darkMode ? '0 3px 8px rgba(255, 255, 255, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.05)'};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SectionHeader = styled.h3`
  grid-column: span 2;
  font-size: .80rem;
  margin-bottom: 10px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
`;

  const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: .75rem;
    margin-bottom: 5px;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  input {
    padding: 3px;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid ;
    color: ${({ darkMode }) => (darkMode ? '#333' : '#333')};
    background-color: ${({ darkMode }) => (darkMode ? '#dcdcdc' : '#f2f2f2')};
    width: 100%;
  }
`;


const FormButtonContainer = styled.div`
text-align: center;
margin-top: 0px;
`

const SubmitButton = styled.button`
background: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#18591d')};
color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
font-weight: bold;
padding: 10px 100px;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s ease;

&:hover {
  background-color: #218838;
}
`;

